var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNoticeGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#454B53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 16.5C10.9999 16.1818 11.1263 15.8765 11.3514 15.6515C11.5764 15.4264 11.8816 15.3 12.1999 15.3C12.5182 15.3 12.8234 15.4264 13.0484 15.6515C13.2735 15.8765 13.3999 16.1818 13.3999 16.5C13.3999 16.8183 13.2735 17.1235 13.0484 17.3485C12.8234 17.5736 12.5182 17.7 12.1999 17.7C11.8816 17.7 11.5764 17.5736 11.3514 17.3485C11.1263 17.1235 10.9999 16.8183 10.9999 16.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1001 13.2L13.1001 7.20004C13.1001 6.96134 13.0053 6.73242 12.8365 6.56364C12.6677 6.39486 12.4388 6.30004 12.2001 6.30004C11.9614 6.30004 11.7325 6.39486 11.5637 6.56364C11.3949 6.73242 11.3001 6.96134 11.3001 7.20004L11.3001 13.2C11.3001 13.4387 11.3949 13.6676 11.5637 13.8364C11.7325 14.0052 11.9614 14.1 12.2001 14.1C12.4388 14.1 12.6677 14.0052 12.8365 13.8364C13.0053 13.6676 13.1001 13.4387 13.1001 13.2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoticeGray);
export default __webpack_public_path__ + "static/media/icon_notice_gray.4941b41f.svg";
export { ForwardRef as ReactComponent };